import axios from 'axios';
import { API_URL } from './utils';
import { BulkUpload } from '../ingestion_tab/BulkUpload';

export const BulkIngestionTab = ({ authHeaders }) => {
  return (
    <BulkUpload
      onSubmit={async (payload) => {
        if (payload?.type === 'cd') {
          try {
            const res = await axios.post(
              `${API_URL}/api/admin/archive/bulk/cds`,
              payload.data,
              { headers: authHeaders() },
            );
            return res.data?.summary ?? res.data;
          } catch (err) {
            const detail =
              err.response?.data?.details ||
              err.response?.data?.error ||
              err.message ||
              'CD bulk upload failed.';
            throw new Error(detail);
          }
        }
        if (payload?.type === 'concert') {
          try {
            const res = await axios.post(
              `${API_URL}/api/admin/archive/bulk/concerts`,
              payload.data,
              { headers: authHeaders() },
            );
            return res.data?.summary ?? res.data;
          } catch (err) {
            const detail =
              err.response?.data?.details ||
              err.response?.data?.error ||
              err.message ||
              'Concert bulk upload failed.';
            throw new Error(detail);
          }
        }
        if (payload?.type === 'oral_history') {
          try {
            if (payload.action === 'peopleSearch') {
              const res = await axios.get(
                `${API_URL}/api/admin/archive/bulk/oral-histories/people-search`,
                {
                  params: { q: payload.q },
                  headers: authHeaders(),
                },
              );
              return res.data;
            }

            const form = new FormData();
            form.append('file', payload.file);
            form.append('format', payload.format || 'auto');
            if (payload.overridePerson)
              form.append('overridePerson', payload.overridePerson);
            if (payload.overrideInterviewer)
              form.append('overrideInterviewer', payload.overrideInterviewer);
            if (payload.overrideDate)
              form.append('overrideDate', payload.overrideDate);

            if (payload.action === 'preview') {
              const res = await axios.post(
                `${API_URL}/api/admin/archive/bulk/oral-histories/preview`,
                form,
                { headers: authHeaders() },
              );
              return res.data?.preview ?? res.data;
            }

            if (payload.action === 'submit') {
              form.append(
                'personDecision',
                JSON.stringify(payload.personDecision || { action: 'leave' }),
              );
              const res = await axios.post(
                `${API_URL}/api/admin/archive/bulk/oral-histories`,
                form,
                { headers: authHeaders() },
              );
              return res.data?.summary ?? res.data;
            }
          } catch (err) {
            const detail =
              err.response?.data?.details ||
              err.response?.data?.error ||
              err.message ||
              'Oral-history upload failed.';
            throw new Error(detail);
          }
        }
        if (payload?.type === 'bios') {
          try {
            const form = new FormData();
            form.append('file', payload.file);

            if (payload.action === 'preview') {
              const res = await axios.post(
                `${API_URL}/api/admin/archive/bulk/bios/preview`,
                form,
                { headers: authHeaders() },
              );
              return res.data?.preview ?? res.data;
            }

            if (payload.action === 'commit') {
              form.append(
                'decisions',
                JSON.stringify(payload.decisions || []),
              );
              const res = await axios.post(
                `${API_URL}/api/admin/archive/bulk/bios`,
                form,
                { headers: authHeaders() },
              );
              return res.data?.summary ?? res.data;
            }
          } catch (err) {
            const detail =
              err.response?.data?.details ||
              err.response?.data?.error ||
              err.message ||
              'Bio upload failed.';
            throw new Error(detail);
          }
        }
        console.warn('Bulk upload payload with unknown type:', payload?.type);
        return null;
      }}
    />
  );
};
